export default class Testimonial {


	// Constructor
	constructor(element) {
		this.element = element;

		this.buttonClick = this.buttonClick.bind(this);
		this.tabClick = this.tabClick.bind(this);

		this.buttonNext = this.element.querySelector('.paged-buttons--next');
		this.buttonPrev = this.element.querySelector('.paged-buttons--prev');
		this.tabs = Array.prototype.slice.call(this.element.querySelectorAll('.section-image-and-tabs--tabs button'), 0);
		this.panels = Array.prototype.slice.call(this.element.querySelectorAll('.section-image-and-tabs--panel'), 0);

		this.buttonNext.addEventListener('click', this.buttonClick);
		this.buttonPrev.addEventListener('click', this.buttonClick);
		for (var i=0, l=this.tabs.length; i<l; i++) {
			this.tabs[i].addEventListener('click', this.tabClick);
		}

		this.index = -1;
		this.changeTab(0);
	}


	// Public Methods
	changeTab(index) {

		if (index !== this.index && index >= 0 && index < this.panels.length) {
			this.index = index;

			this.buttonNext.classList.remove('is-disabled');
			this.buttonPrev.classList.remove('is-disabled');
			if (this.index === this.panels.length - 1) {
				this.buttonNext.classList.add('is-disabled');
			}
			if (this.index === 0) {
				this.buttonPrev.classList.add('is-disabled');
			}

			for (var i=0, l=this.tabs.length; i<l; i++) {
				if (i === this.index) {
					this.tabs[i].parentNode.classList.add('active');
					this.panels[i].classList.add('active');
				} else {
					this.tabs[i].parentNode.classList.remove('active');
					this.panels[i].classList.remove('active');
				}
			}

		}
	}


	// Event Handlers
	buttonClick(event) {
		event.preventDefault();
		if (event.currentTarget === this.buttonPrev) {
			this.changeTab(this.index - 1);
		} else {
			this.changeTab(this.index + 1);
		}
	}
	tabClick(event) {
		event.preventDefault();
		const index = this.tabs.indexOf(event.currentTarget);
		this.changeTab(index);
	}


}
